var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#696969;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,7.8v34.4h34.4V7.8H7.8z M10.9,10.9h28.1v28.1H10.9V10.9z M31.6,23.4c-2.2,0-3.7,1.4-3.7,3.3 c0,2,1.2,3,3,3.8l0.6,0.3c1.1,0.5,1.8,0.8,1.8,1.7c0,0.7-0.7,1.2-1.7,1.2c-1.2,0-1.9-0.7-2.5-1.5l-2,1.2c0.7,1.5,2.2,2.6,4.6,2.6 c2.4,0,4.2-1.2,4.2-3.5c0-2.1-1.2-3-3.3-3.9L32,28.2c-1.1-0.5-1.5-0.8-1.5-1.5c0-0.6,0.5-1.1,1.2-1.1c0.7,0,1.2,0.3,1.6,1.1l2-1.3 C34.4,24,33.2,23.4,31.6,23.4z M22.5,23.6v8.5c0,1.2-0.5,1.6-1.4,1.6c-0.9,0-1.2-0.6-1.6-1.3l-2,1.2c0.6,1.3,1.8,2.3,3.8,2.3 c2.2,0,3.8-1.2,3.8-3.8v-8.6H22.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.38ba0007aae61d02a11c48bb73cff80a.svg";
export { ForwardRef as ReactComponent };